import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import ProjectGranteeBasicInfoForm from './ProjectGranteeBasicInfoForm'
import TableReport from '../tableReport/TableReport'
import {
  searchProjectGranteeBasicInfo,
  exportProjectGranteeBasicInfo,
} from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'

export default function ProjectGranteeBasicInfoWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  useEffect(() => {
    // setDataTable(mockCallData)
  }, [])

  const handleCancel = () => {
    setValueNullField()
    setDataTable(null)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let request = {
      firstNameGrantee: data.firstNameGrantee,
      lastNameGrantee: data.lastNameGrantee,
      emailGrantee: data.emailGrantee,
      idCardGrantee: data.idCardGrantee,
      telephoneGrantee: data.telephoneGrantee,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      idCardResponsinator: data.idCardResponsinator,
      telephoneResponsinator: data.telephoneResponsinator,
      emailResponsinator: data.emailResponsinator,
      // idCard: data.idCard,
      organizationName: data.organizationName,
      taxId: data.taxId,
      pageNumber: 1,
      pageSize: pagSize,
    }

    setCondition(data)
    handlePreviewReport(request)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchProjectGranteeBasicInfo(request)
      console.log('response', response)

      if (response.model) {
        setDataTable(response.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    // console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      firstNameGrantee: condition.firstNameGrantee,
      lastNameGrantee: condition.lastNameGrantee,
      emailGrantee: condition.emailGrantee,
      idCardGrantee: condition.idCardGrantee,
      telephoneGrantee: condition.telephoneGrantee,
      firstNameResponsinator: condition.firstNameResponsinator,
      lastNameResponsinator: condition.lastNameResponsinator,
      idCardResponsinator: condition.idCardResponsinator,
      telephoneResponsinator: condition.telephoneResponsinator,
      emailResponsinator: condition.emailResponsinator,
      // idCard: condition.idCard,
      organizationName: condition.organizationName,
      taxId: condition.taxId,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handleOnClickExport = (data) => {
    console.log('handleOnClickExport ', data)

    let request = {
      firstNameGrantee: data.firstNameGrantee,
      lastNameGrantee: data.lastNameGrantee,
      emailGrantee: data.emailGrantee,
      idCardGrantee: data.idCardGrantee,
      telephoneGrantee: data.telephoneGrantee,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      idCardResponsinator: data.idCardResponsinator,
      telephoneResponsinator: data.telephoneResponsinator,
      emailResponsinator: data.emailResponsinator,
      // idCard: data.idCard,
      organizationName: data.organizationName,
      taxId: data.taxId,
    }

    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportProjectGranteeBasicInfo(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลผู้รับผิดชอบโครงการหรือผู้รับทุน`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.searchObject.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <ProjectGranteeBasicInfoForm
          schema={formSchema.searchObject}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          // handelPreview={onSubmit}
          clearValue={clearValue}
        />

        <hr />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema.searchObject.buttonText}
          onCancel={handleSubmit(handleCancel)}
          onSave={handleSubmit(onSubmit)}
        />
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <div style={{ marginTop: 30 }}>
            <TableReport
              schema={dataTable}
              headerHeightSize={40}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              onReload={handelGetSchemaOnReload}
              onClickExport={handleSubmit(handleOnClickExport)}
            />
          </div>
          <br />
        </>
      )}
    </>
  )
}
